import normaliseElementTopValue from 'src/js/modules/highlighter/helpers/normalise-element-top-value';

const getElementBoundsForHighlighter = (element, scrollTop, computedStyles) => {
  const { height, width, left, top } = element.getBoundingClientRect();

  const elementTop = normaliseElementTopValue({ element, top, scrollTop });
  const highlighterTop = elementTop + scrollTop;

  const elementBounds = {
    width,
    height,
    left,
    top: highlighterTop,
  };

  if (element.matches('ws-column')) {
    const columnPadding = parseInt(computedStyles.paddingLeft, 10);
    elementBounds.left += columnPadding;
    elementBounds.width -= columnPadding * 2;
  }

  return elementBounds;
};

export default getElementBoundsForHighlighter;
